export default __webpack_public_path__ + "8496d9842cde37e2c228f8cd80bacfcc.png";